import {object, string, array} from 'yup';

export const adminGroupValidator = object().shape({
  name: string().required('Fill in your group name'),
  groupType: string(),
  groupAdmin: string(),
  users: array(),
});
